<div class="traffic-light-mini">
  <svg  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path class="outer-circle" [attr.fill]="outerCircleColor" d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" />
    <path [attr.fill]="innerCircleColor" d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0z"/>
  </svg>
</div>
